import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { cn } from '@/lib/utils';

export function CompactPromptBox({ onSubmit, placeholder = 'Ask a question...', className }) {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.trim()) {
      onSubmit(prompt.trim());
      setPrompt('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const isDisabled = !prompt.trim();

  return (
    <form onSubmit={handleSubmit} className={cn('relative w-full', className)}>
      <input
        type="text"
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="w-full h-10 pl-4 pr-12 rounded-xl glass-input text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 transition-all duration-200"
      />
      <button
        type="submit"
        disabled={isDisabled}
        className={cn(
          'absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg',
          'transition-all duration-200',
          isDisabled
            ? 'text-muted-foreground/30 cursor-not-allowed'
            : 'text-primary hover:bg-white/20 active:scale-95'
        )}
      >
        <Send className="h-4 w-4" />
      </button>
    </form>
  );
}
